// 시간 단위 도우미(60Hz 틱). config.ts와 스킬 타임라인 데이터(shared/skills)가 함께 쓰는 잎 모듈이라 서로 순환 import가 없다.
export const TICK_HZ = 60;

/** 밀리초 → 틱(반올림). COMBAT-FEEL 6장: 실제 화면과 ±1프레임 이내여야 한다. */
export const ms = (v: number): number => Math.max(0, Math.round((v * TICK_HZ) / 1000));
